export const SELECTED_VENDOR_ID_COOKIE = 'selectedVendorId';
export const SELECTED_VENDOR_ID_COOKIE_EXPIRATION = 365;
